module.exports = __webpack_public_path__ + "img/coupon.5601e27b.png";